import { EmployeeStatus } from 'enums';
import { User } from 'store';

export const isUserRelevant = (currentUser?: User) => {
  if (currentUser) {
    return (
      currentUser.employmentStatus === EmployeeStatus.Employee ||
      currentUser.employmentStatus === EmployeeStatus.Evaluation
    );
  }

  return undefined;
};
